import React from 'react';

import { Box } from '@chakra-ui/react';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@mesh.ai/rabbit';
import { Link } from 'react-router-dom';

type Props = {
  Filters?: React.ReactNode;
  children?: React.ReactNode;
};

export const DeerBreadcrumbs = ({ breadcrumbs }) => (
  <Box
    sx={{
      ol: {
        paddingLeft: 0,
        marginBlockStart: 0,
        marginBlockEnd: 0,
      },
    }}
  >
    <Breadcrumb>
      <BreadcrumbList>
        {breadcrumbs.items.map(({ label, to }) => (
          <BreadcrumbItem style={{ gap: '2px' }} key={`breadcrumb-link-${to}-${label}`}>
            <BreadcrumbLink asChild key={`breadcrumb-link-${to}-${label}`}>
              <Link to={to}>{label}</Link>
            </BreadcrumbLink>
            <BreadcrumbSeparator />
          </BreadcrumbItem>
        ))}
        <BreadcrumbPage>{breadcrumbs?.page?.label}</BreadcrumbPage>
      </BreadcrumbList>
    </Breadcrumb>
  </Box>
);

const Layout = ({ Filters, children }: Props) => {
  const showFilters = !!Filters;

  return (
    <Box className="layout-intent-wrapper">
      {/* <DeerBreadcrumbs breadcrumbs={breadcrumbs} /> */}
      {/* HEADER/INTENT FILTERS */}
      {showFilters && Filters}
      {children}
    </Box>
  );
};

export { Layout };
